import type { Nullable, Nullish } from "shared/types";
import type {
  BroadcastProvider,
  BroadcastProviderOwner,
} from "shared/types/mentions";

function resolveBroadcastProvider(
  mention: BroadcastProviderOwner,
  mediaRequest?: Nullable<BroadcastProviderOwner>
): Nullish<BroadcastProvider> {
  return mediaRequest?.broadcast_provider ?? mention.broadcast_provider;
}

export function isBroadcastProviderSupported(
  mention: BroadcastProviderOwner,
  mediaRequest?: Nullable<BroadcastProviderOwner>
): boolean {
  return resolveBroadcastProvider(mention, mediaRequest)?.supported === true;
}

export function isBroadcastProviderUnsupported(
  mention: BroadcastProviderOwner,
  mediaRequest?: Nullable<BroadcastProviderOwner>
): boolean {
  return resolveBroadcastProvider(mention, mediaRequest)?.supported === false;
}

export function isKinetiqBroadcastProvider(
  mention: BroadcastProviderOwner,
  mediaRequest?: Nullable<BroadcastProviderOwner>
): boolean {
  return resolveBroadcastProvider(mention, mediaRequest)?.name === "kinetiq";
}
